<template>
    <div class="tableList documentation__categoryList documentation__categoryList--active" v-if="children.length">
        <router-link v-bind:class="{'tableList__item': true, 'tableList__item--selected': isActive(child.slug)}" :to="{name: routeName(), params: {slug: child.extendedSlug}}" v-for="child in children" :key="child.id">
            {{child.name}}
        </router-link>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import filter from 'lodash/filter';
    import isUndefined from 'lodash/isUndefined';
    import {SLUG_SEPARATOR} from './const';

    export default {
        name:     'DownloadCategoryList',
        props:    {
            children: Array,
        },
        computed: {
            ...mapGetters('cad', ['categories', 'type'])
        },
        methods:  {
            hasChildren(slug) {
                return filter(this.categories, category => slug == category.parentSlug).length;
            },
            isActive(slugCategory) {
                const slug = this.$route.params.slug;
                if (isUndefined(slug)) {
                    return false;
                }
                return slug.split(SLUG_SEPARATOR).indexOf(slugCategory) !== -1;
            },
            routeName() {
                switch (this.type) {
                    case 'cad':
                        return 'cad.category';
                        break
                    default:
                        return 'download.category';
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/cad/CategoryList.vue